import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class FileUploadStore {
  selectedNamespace: string = '';
  uploadedFile: string = '';

  constructor() {
    makeObservable(this, {
      selectedNamespace: observable,
      uploadedFile: observable,
      setSelectedNamespace: action,
      removeFileData: action,
      setUploadedFile: action,
    });
    makePersistable(this, {
      name: 'FileUploadStore',
      properties: ['selectedNamespace', 'uploadedFile'],
      storage: window.localStorage,
    });
  }
  setUploadedFile(url: string) {
    this.uploadedFile = url;
  }
  setSelectedNamespace(namespace: string) {
    this.selectedNamespace = namespace;
  }
  removeFileData() {
    this.selectedNamespace = '';
    this.uploadedFile = '';
  }
}

export default FileUploadStore;
